import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

// The dialogs supply their own heading, so the document's own H1 would read as a duplicate there.
export const stripLeadingTitle = (markdown) => String(markdown || "").replace(/^#[^\n]*\n+/, "");

const components = {
  h1: (props) => <h1 className="text-3xl font-bold tracking-tight text-foreground" {...props} />,
  h2: (props) => <h2 className="mt-8 text-lg font-semibold text-foreground" {...props} />,
  h3: (props) => <h3 className="mt-6 text-base font-semibold text-foreground" {...props} />,
  p: (props) => <p className="mt-3 text-sm leading-6 text-muted-foreground" {...props} />,
  ul: (props) => (
    <ul className="mt-3 list-disc space-y-2 pl-5 text-sm leading-6 text-muted-foreground" {...props} />
  ),
  ol: (props) => (
    <ol className="mt-3 list-decimal space-y-2 pl-5 text-sm leading-6 text-muted-foreground" {...props} />
  ),
  li: (props) => <li className="pl-1" {...props} />,
  strong: (props) => <strong className="font-semibold text-foreground" {...props} />,
  a: (props) => <a className="text-primary underline underline-offset-2" {...props} />,
  hr: () => <hr className="my-8 border-border" />,
  // Retention and provider tables must never widen the page on a phone.
  table: (props) => (
    <div className="mt-4 overflow-x-auto rounded-lg border border-border">
      <table className="w-full border-collapse text-left text-sm" {...props} />
    </div>
  ),
  thead: (props) => <thead className="bg-muted/40" {...props} />,
  th: (props) => (
    <th
      className="border-b border-border px-3 py-2 align-top text-xs font-semibold uppercase tracking-wide text-foreground"
      {...props}
    />
  ),
  td: (props) => (
    <td className="border-b border-border px-3 py-2 align-top text-sm leading-6 text-muted-foreground" {...props} />
  ),
};

export const LegalMarkdown = ({ markdown }) => (
  <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
    {markdown}
  </ReactMarkdown>
);
